import React, { Component, Fragment } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';

export const archiveVesselTypeMutation = gql`
  mutation archiveVesselType($id: Int!) {
    archiveVesselType(id: $id) {
      id
    }
  }
`;

export class VesselTypeArchive extends Component {
  state = {
    isOpen: false,
    submitting: false,
    error: null
  };

  setError = error => {
    this.setState({ error });
  };

  setSubmitting = submitting => {
    this.setState({ submitting });
  };

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  renderNopeModalInner = () => {
    // You can't delete a vessel type if it has variants
    const { variants } = this.props.vesselType;

    return (
      <Fragment>
        <ModalHeader toggle={this.onToggle}>Cannot archive</ModalHeader>
        <ModalBody>
          <p className="mb3">
            You can't archive this vessel type as some product variants use it. You'll need to remove it from these
            product variants before you can archive:
          </p>
          <ul className="mb0">
            {variants.map(variant => (
              <li key={variant.id}>
                <Link to={`/products/${variant.productId}`}> {variant.name}</Link>
              </li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onToggle}>
            Ok
          </Button>{' '}
        </ModalFooter>
      </Fragment>
    );
  };

  renderConfirmationModalInner = () => {
    const { client, vesselType, history } = this.props;
    const { name } = vesselType;
    const { submitting, error } = this.state;
    return (
      <Mutation mutation={archiveVesselTypeMutation}>
        {archiveVesselType => (
          <Fragment>
            <ModalHeader toggle={this.onToggle}>Are you sure?</ModalHeader>
            <ModalBody>
              {error && <Alert color="danger">{error}</Alert>}
              Are you sure you want to archive the vessl type <em>{name}</em>?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.onToggle}>
                Cancel
              </Button>{' '}
              <Button
                disabled={submitting}
                color="primary"
                onClick={async () => {
                  try {
                    this.setSubmitting(true);
                    await archiveVesselType({
                      variables: {
                        id: vesselType.id
                      }
                    });
                    // Clear cache
                    client.resetStore();
                    history.push(`/settings/vesselTypes?archived=${name}`);
                  } catch (err) {
                    this.setSubmitting(false);
                    this.setError('An unknown error occured');
                  }
                }}
              >
                Archive
              </Button>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  };

  render() {
    const { className, vesselType } = this.props;

    if (!vesselType) {
      // In some cases where the type comes though asyncronously, there is a chance that it
      // does not exist yet. If that is the case, don't render anything
      return null;
    }

    return (
      <Fragment>
        <Button className={className} color="danger" outline onClick={this.onToggle}>
          Archive
        </Button>
        <Modal isOpen={this.state.isOpen} toggle={this.onToggle}>
          {vesselType.variants.length ? this.renderNopeModalInner() : this.renderConfirmationModalInner()}
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(withApollo(VesselTypeArchive));



// WEBPACK FOOTER //
// ./src/containers/vesselTypeArchive/vesselTypeArchive.jsx